
import React from 'react';

interface CTASectionProps {
  /** Callback to open the modal. If not provided, a no‑op function will be used. */
  onOpenModal?: () => void;
}

/**
 * CTASection – a call‑to‑action component with a background illustration.
 *
 * The component now safely handles a missing `onOpenModal` prop by providing a
 * default no‑operation function. This prevents runtime errors when the prop is
 * omitted or undefined.
 */
export default function CTASection({ onOpenModal = () => {} }: CTASectionProps) {
  return (
    <section className="relative py-36 overflow-hidden">
      <div className="absolute inset-0 bg-[#F7F9FC]"></div>
      <div className="absolute top-0 right-0 w-[45%] h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/f5dffe17757020b426b285292f54c860.jpg"
          alt="Growth visualization"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F7F9FC] via-[#F7F9FC]/80 to-transparent"></div>
      </div>

      <div className="relative max-w-[960px] mx-auto px-8 lg:px-20 text-center">
        <h2 className="text-[48px] font-semibold text-[#0B1F3A] mb-7 leading-tight">
          Ready to scale with precision?
        </h2>
        <p className="text-lg text-[#0B1F3A]/65 leading-relaxed max-w-[600px] mx-auto mb-12">
          If your organization requires structured growth, regulatory alignment, and measurable operational improvement, we’re
          ready to build the system behind your next phase.
        </p>
        <div className="flex flex-col items-center gap-4">
          <button
            onClick={onOpenModal}
            className="bg-[#1EB6B0] text-white px-12 h-14 rounded-md text-base font-medium hover:bg-[#1EB6B0]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Schedule Executive Strategy Call
          </button>
          <button className="border-2 border-[#0B1F3A]/25 text-[#0B1F3A] px-12 h-14 rounded-md text-base font-medium hover:border-[#0B1F3A]/45 transition-all whitespace-nowrap cursor-pointer">
            Download Capabilities Overview
          </button>
        </div>
      </div>
    </section>
  );
}
